import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    // Ensure scrollRestoration stays manual (reinforces the index.html inline script)
    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    // Clean up stale scroll locks on every route change.
    // Radix Dialog/Sheet uses react-remove-scroll which can leave
    // body classes/attributes/styles that block interaction.
    useEffect(() => {
        if (document.body.hasAttribute('data-scroll-locked')) {
            document.body.removeAttribute('data-scroll-locked');
        }
        const classes = [...document.body.classList];
        classes.forEach(cls => {
            if (cls.startsWith('block-interactivity-') || cls === 'with-scroll-bars-hidden') {
                document.body.classList.remove(cls);
            }
        });
        document.querySelectorAll('[class*="allow-interactivity-"]').forEach(el => {
            [...el.classList].forEach(cls => {
                if (cls.startsWith('allow-interactivity-')) {
                    el.classList.remove(cls);
                }
            });
        });
        document.querySelectorAll('[data-radix-portal]').forEach(portal => {
            if (!portal.querySelector('[data-state="open"]')) {
                portal.remove();
            }
        });
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        document.body.style.paddingRight = '';
        document.body.style.marginRight = '';
        document.body.style.pointerEvents = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.visibility = '';
    }, [pathname]);

    // Scroll to top on every route change — runs before paint
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
};

export default ScrollToTop;
